/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCachedSuggestionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_suggestions.pb'
import {GetCachedSuggestionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_suggestions.pb'


export const getCachedSuggestions = (request: GetCachedSuggestionsRequest, options?: CashRequestOptions) => post<GetCachedSuggestionsRequest, GetCachedSuggestionsResponse>("/cash-app/goose-cash/v3/get-cached-suggestions", request, {...options, rejectOnError: true })